import './typingAnimation.css';

function TypingAnimation() {
  return (
    <div className="typingAnimation">
      <ul className="dynamic-txts">
        <li>
          <span>healthcare</span>
        </li>
        <li>
          <span>doctor</span>
        </li>
        {/* <li>
          <span>stress level</span>
        </li>
        <li>
          <span>Exceptional</span>
        </li> */}
      </ul>
    </div>
  );
}

export default TypingAnimation;
